const selector = 'style[data-yiguige-theme-style]';

function removeOwner(owner) {
  for (const style of document.head.querySelectorAll(selector)) {
    if (style.dataset.styleOwner === owner) style.remove();
  }
}

function promote(style) {
  if (style.parentElement === document.head) return;
  const previous = [...document.head.querySelectorAll(selector)].filter(
    (item) => item.dataset.styleKey === style.dataset.styleKey
  );
  if (previous.length) {
    previous[0].replaceWith(style);
    for (const duplicate of previous.slice(1)) duplicate.remove();
  } else {
    document.head.append(style);
  }
}

document.addEventListener('shopify:section:unload', (event) => {
  removeOwner(event.detail.sectionId);
});

const observer = new MutationObserver((records) => {
  for (const record of records) {
    for (const node of record.removedNodes) {
      if (node instanceof Element && node.id.startsWith('shopify-section-')) {
        removeOwner(node.id.slice('shopify-section-'.length));
      }
    }
  }
  for (const record of records) {
    for (const node of record.addedNodes) {
      if (!(node instanceof Element) || !node.isConnected) continue;
      if (node.matches(selector)) promote(node);
      for (const style of node.querySelectorAll(selector)) promote(style);
    }
  }
});
observer.observe(document.body, { childList: true, subtree: true });
for (const style of document.body.querySelectorAll(selector)) promote(style);
